
export default {
    name: 'SuggestionSlider',
    props: {
        categories: {
            type: Array,
            default: () => []
        }
    }
}
